import {
    Modal, Table, Checkbox, Button,
} from 'appkit-react';

const ColumnsModal = ({
    showColumnsModal, setShowColumnsModal, onHandleChange,
    selectedNode, colsData,
}) => {
    const { allChecked, columns: data } = colsData ? colsData.filter(item => item.id === selectedNode.id)[0] : {};

    /* List of columns of Table for Columns Modal */
    const columns = [{
        Header: () => (<Checkbox checked={allChecked} onChange={onHandleChange} name="checkAll">All</Checkbox>),
        accessor: 'column',
        Cell: props => {
            const { original: { isChecked, column } } = props;
            return <Checkbox checked={isChecked} onChange={onHandleChange} name={column} value={column} />;
        },
        minWidth: 20,
    }, {
        Header: 'Columns',
        accessor: 'column',
        minWidth: 50,
    }, {
        Header: 'Data Type',
        accessor: 'dataType',
        minWidth: 20,
    }];
    return (
        <Modal
            className="baseline-modal-showcase true-comply-datarecon__column-modal"
            visible={showColumnsModal}
        >
            <div className="true-comply-datarecon__column-modal-headsection">
                <p>SELECT COLUMNS</p>
                <span onClick={() => setShowColumnsModal(false)} className="appkiticon icon-close-outline" aria-hidden="true" />
            </div>
            <div className="true-comply-datarecon__column-modal-bodysection">
                <Table
                    data={data}
                    columns={columns}
                    showPagination
                    defaultPageSize={10}
                    sortable={false}
                />
            </div>
            <div className="true-comply-datarecon__column-modal-footersection">
                <Button size="md" onClick={() => setShowColumnsModal(false)} aria-hidden="true">SELECT</Button>
            </div>
        </Modal>
    );
};

export default ColumnsModal;
